export default __webpack_public_path__ + "static/wordpress-d00b5b7f080374d9bb76438ebca9aa29.jpg";